import {
  compose,
  prop,
  propOr,
  always,
  cond,
  T,
  ifElse,
  length,
  gt,
  __,
  not,
} from 'ramda';

import {
  ANONYMOUS,
  DIRECT_TO_PAY,
  ALREADY_PREMIUM,
  FREE_TRIAL_ELIGIBLE,
} from 'app/features/user/constants/userFlow';

const user = prop('user');
const userId = compose(prop('id'), user);
const userSessionId = compose(prop('sessionId'), user);
const userEmail = compose(prop('email'), user);
const username = compose(prop('username'), user);
const userAccessType = compose(prop('accessType'), user);
const isUserPremium = compose(prop('isPremium'), user);
const userCountryCode = compose(prop('countryCode'), user);
const userLocale = compose(prop('locale'), user);
const isUserAuthenticated = compose(propOr(false, 'isAuthenticated'), user);
const isUserAnonymous = compose(not, isUserAuthenticated);
const isDirectToPay = compose(prop('isDirectToPay'), user);
const isEligibleForFreeTrial = compose(prop('isEligibleForFreeTrial'), user);

const dashedUserLocale = compose(
  locale => `${locale.substring(0, 2)}-${locale.substring(2)}`,
  userLocale,
);

const userGreeting = ifElse(username, username, userEmail);

const isGreetingLongerThan20Chars = compose(gt(__, 20), length, userGreeting);

const isGreetingLongerThan42Chars = compose(gt(__, 42), length, userGreeting);

const userFlow = cond([
  [isUserPremium, always(ALREADY_PREMIUM)],
  [isDirectToPay, always(DIRECT_TO_PAY)],
  [isEligibleForFreeTrial, always(FREE_TRIAL_ELIGIBLE)],
  [T, always(ANONYMOUS)],
]);

export {
  userSessionId,
  userLocale,
  dashedUserLocale,
  user,
  username,
  isUserAuthenticated,
  userAccessType,
  userId,
  isUserPremium,
  isEligibleForFreeTrial,
  userEmail,
  userCountryCode,
  isDirectToPay,
  userFlow,
  userGreeting,
  isGreetingLongerThan20Chars,
  isUserAnonymous,
  isGreetingLongerThan42Chars,
};
